import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { getTableroSac } from "modules/tableros/services/tableroSac";
import { groupDashboard } from "../utils/dashboardModel";

export const useTableroSac = (tipo = "comercios", refreshFlag) => {
  const [state, setState] = useState({
    tipo,
    datos: [],
    loading: true,
    error: "",
    updatedAt: null,
  });
  const current = useRef(0);
  const controller = useRef(null);
  const recargar = useCallback(async () => {
    const request = ++current.current;
    controller.current?.abort();
    const abort = new AbortController();
    controller.current = abort;
    setState((previous) => ({
      ...(previous.tipo === tipo ? previous : { tipo, datos: [], updatedAt: null }),
      loading: true,
      error: "",
    }));
    try {
      const response = await getTableroSac(tipo, { signal: abort.signal });
      if (!Array.isArray(response?.data))
        throw new Error("El servicio devolvió un formato de datos inválido");
      if (request === current.current && !abort.signal.aborted)
        setState({ tipo, datos: response.data, loading: false, error: "", updatedAt: new Date() });
    } catch (error) {
      if (request === current.current && !abort.signal.aborted)
        setState((previous) => ({
          ...previous,
          loading: false,
          error: error.message || "No se pudo cargar el tablero",
        }));
    }
  }, [tipo]);
  useEffect(() => {
    recargar();
    return () => {
      ++current.current;
      controller.current?.abort();
    };
  }, [recargar, refreshFlag]);
  const datos = useMemo(
    () => (state.tipo === tipo ? state.datos : []),
    [state.tipo, state.datos, tipo]
  );
  const groups = useMemo(() => groupDashboard(datos, tipo), [datos, tipo]);
  const stats = useMemo(
    () => ({
      total: groups.length,
      sinNovedad: groups.filter((group) => group.status === "ok").length,
      posiblesFallo: groups.filter((group) => group.status === "partial").length,
      conFallo: groups.filter((group) => group.status === "fail").length,
      unknown: groups.filter((group) => group.status === "unknown").length,
    }),
    [groups]
  );
  return {
    ...state,
    datos,
    groups,
    stats,
    loading: state.tipo !== tipo || state.loading,
    error: state.tipo === tipo ? state.error : "",
    updatedAt: state.tipo === tipo ? state.updatedAt : null,
    recargar,
  };
};
